export const SET_DEVICE = 'SET_DEVICE';
export const SET_VERSION = 'SET_VERSION';
export const SET_REDIRECT_PATH = 'SET_REDIRECT_PATH';


// WEBPACK FOOTER //
// ./src/redux_related/ui/actions.js